import { ServiceReportComponent } from './service-report/service-report.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AcademicRiskReportComponent } from './academic-risk-report/academic-risk-report.component';
import { CommunicationEventReportComponent } from './communication-event-report/communication-event-report.component';
import { CountsComponent } from './counts/counts.component';
import { GraduationReportComponent } from './graduation-report/graduation-report.component';
import { InaReportComponent } from './ina-report/ina-report.component';
import { PfsReportComponent } from './pfs-report/pfs-report.component';
import { EnrollmentReportComponent } from './enrollment-report/enrollment-report.component';

const routes: Routes = [
    {
        path: 'instant-eligibility-counts',
        component: CountsComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Counts Report'
        }
    },
    {
        path: 'enrollment-report',
        component: EnrollmentReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Enrollment Report'
        }
    },
    {
        path: 'graduation-report',
        component: GraduationReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Graduation Report'
        }
    },
    {
        path: 'academic-risk-report',
        component: AcademicRiskReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Academic Risk Report'
        }
    },
    {
        path: 'pfs-report',
        component: PfsReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'PFS Report'
        }
    },
    {
        path: 'communication-events-report',
        component: CommunicationEventReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Communication Events Report'
        }
    },
    {
        path: 'ina-ilp-report',
        component: InaReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'INA/ILP Report'
        }
    },
    {
        path: 'student-service-lists',
        component: ServiceReportComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Service Report'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChildReportsRoutingModule {}
